//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const LOGIN = "/auth/login"
export const JWT_LOGIN = "/post-jwt-login"
export const PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//LOGOUT
export const LOGOUT = "/auth/logout"

//ACCESS TOKEN
export const ACCESS_TOKEN = "/auth/refreshToken"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"
export const ADD_NEW_INVOICE = "/add/invoice"
export const UPDATE_INVOICE = "/update/invoice"
export const DELETE_INVOICE = "/delete/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"

// MODULE
export const GET_MODULE = "/privilage/module/options"

//MENU
export const GET_MENU = "/menu"

//OPTIONS
export const GET_PRIVILEGES = "/options/privileges"
export const GET_MODULES = "/options/modules"
export const GET_USERS_OPTIONS = "/options/users"
export const GET_COUNTRIES_OPTIONS = "/options/countries"
export const GET_STATES_OPTIONS = "/options/states"
export const GET_DISTRICTS_OPTIONS = "/options/districts"
export const GET_COMPANIES_OPTIONS = "/options/companies"
export const GET_BRANCHES_OPTIONS = "/options/branches"
export const GET_CATEGORY_OPTIONS = "/options/category"
